// extracted by mini-css-extract-plugin
export var container = "_5y-0";
export var error = "_5y-9";
export var label = "_5y-5";
export var light = "_5y-6";
export var md = "_5y-3";
export var sm = "_5y-2";
export var thin = "_5y-8";
export var thinBold = "_5y-7";
export var vertical = "_5y-4";
export var xs = "_5y-1";